<template>
    <div :class="drawer ? 'drawer-open' : ''">
        <NotificationShow/>
        <div class="notifications left">
            <PushNotifications position="left" />
        </div>
        <div class="notifications right">
            <PushNotifications position="right" />
            <ActiveCalls/>
        </div>

        <v-navigation-drawer
            v-model="drawer"
            app
            dark
            color="blue-grey darken-4"
            :mobile-breakpoint="1300"
        >
            <navigation />
        </v-navigation-drawer>

        <Header @navBarChange="drawer = !drawer" />
        <slot></slot>
        <WorkLocationDailySelection />
        <WindmillPrank />
    </div>
</template>

<script>
import Navigation from "@/components/Layout/Partials/Navigation";
import Header from "@/components/Layout/Partials/Header";
import NotificationShow from "@/components/Layout/Partials/Notification";
import ActiveCalls from "@/components/PhoneCall/Active";
import PushNotifications from "@/components/Layout/Partials/PushNotifications";
import WindmillPrank from "@/components/AprilFools/WindmillPrank.vue";
import WorkLocationDailySelection
    from "@/components/User/WorkLocation/WorkLocationDailySelection.vue";

export default {
    components: {
        WindmillPrank,
        WorkLocationDailySelection,
        PushNotifications,
        NotificationShow,
        Navigation,
        Header,
        ActiveCalls
    },
    data() {
        return {
            drawer: null,
        }
    },
}
</script>
